import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    tickets: [],
    ticketProfile: {}
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindTickets: firestoreAction(context => {
      return context.bindFirestoreRef(
        "tickets",
        db.collection("tickets").orderBy("createdDate", "desc")
      );
    }),

    bindTicketProfile: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "ticketProfile",
        db.collection("tickets").doc(id)
      );
    })
  },
  getters: {}
};
